import React, { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import OperatorCreate from "./CreateOperator";
import ListOperator from "./ListOperator";
import AttendanceDashboard from "./AttendanceDashboard";
import AttendanceMap from "./AttendanceMap";
import AttendanceHistory from "./AttendanceHistory";
import LocationHistory from "./LocationHistory";

class Routes extends Component {
  render() {
    return (
      <Switch>
        <Route
          path="/:farm_id/operator/attendance/dashboard"
          component={AttendanceDashboard}
        />
        <Route
          path="/:farm_id/operator/attendance/map"
          component={AttendanceMap}
        />
        <Route
          path="/:farm_id/operator/attendance/history"
          component={AttendanceHistory}
        />
        <Route
          path="/:farm_id/operator/location/history"
          component={LocationHistory}
        />
        <Route
          path="/:farm_id/operator/:operator_id/change"
          component={OperatorCreate}
        />
        <Route path="/:farm_id/operator/add" component={OperatorCreate} />
        <Route path="/:farm_id/operator/" component={ListOperator} />
      </Switch>
    );
  }
}

export default withRouter(Routes);
